<template>
  <div id="page-homeapproval" class="d-flex">
    <MainBarMenu />
    <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="page-approval py-0 mt-0 mb-0">
        <div class="container-fluid pt-5">
          <p class="title-1 mb-0">
            SOLICITUD PERMISO SINDICAL - {{ this.$route.params.id }}
          </p>
          <div class="row">
            <template v-if="processing">
              <b-col cols="12" class="text-center">
                <div class="position-fixed" id="loader" />
              </b-col>
            </template>
            <template v-else>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div
                  class="cont-approval-text d-flex flex-column justify-content-around mt-0 mt-md-0"
                >
                  <!-- .cont-title -->
                  <form
                    action=""
                    class="form-approval mt-5 mb-5 mb-md-5 d-flex flex-column flex-md-row align-items-center"
                  >
                    <div role="tablist" class="w-100">
                      <small
                        v-show="
                          tickets && licenseIsEdit && ticketsCanBeApproved
                        "
                      >
                        <b-alert show variant="info">
                          Esta solicitud tiene tiquetes aereos por aprobar, por
                          favor aprobar/rechazar.
                        </b-alert>
                      </small>

                      <div v-if="stateLicense.value">
                        <b-alert show variant="danger">
                          {{ stateLicense.msj }}
                        </b-alert>
                      </div>

                      <b-card no-body class="mb-3">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            class="button1 d-flex flex-row justify-content-between align-items-center"
                            block
                            v-b-toggle.accordion-1
                            variant="info"
                          >
                            1. Aprobación de permiso por días
                            <span class="when-opened ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-up.svg"
                              />
                            </span>
                            <span class="when-closed ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-down.svg"
                              />
                            </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse
                          id="accordion-1"
                          accordion="my-accordion"
                          role="tabpanel"
                          visible
                        >
                          <b-card-body v-if="licenseIsEdit" class="px-5">
                            <div>
                              <p
                                class="p2"
                                style="
                                  font-size: 16px;
                                  line-height: 18px !important;
                                "
                              >
                                Selecciona los días que apruebas para cada
                                trabajador. Marca bajo su nombre si el primer
                                día de permiso, el colaborador está en turno
                                nocturno, nos ayuda a conocer las horas de
                                ausentismo.
                              </p>
                              <div class="row">
                                <div class="col-12 text-right">
                                  <p class="p2">{{ this.stringMonths }}</p>
                                </div>
                              </div>
                              <div style="overflow-x: auto" align="center">
                                <table border="0" style="white-space: nowrap">
                                  <tr>
                                    <td align="center">
                                      <p class="p2"><b>Colaboradores</b></p>
                                    </td>
                                    <td align="center"></td>
                                    <td
                                      align="center"
                                      v-for="(day, key_name_day) in this
                                        .nameDaysLicense"
                                      :key="key_name_day"
                                    >
                                      {{ day.day }}
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="worker in this.employees"
                                    v-bind:key="worker.core_employee.sharp_id"
                                  >
                                    <td>
                                      <b>{{ worker.core_employee.name }}</b>
                                      <br />
                                      <label>
                                        <input
                                          class="mycheck"
                                          type="checkbox"
                                          v-model="turnos[worker.sharp_id]"
                                        />
                                        Turno nocturno
                                      </label>
                                      <br />
                                      <div
                                        class="mb-3 px-2"
                                        v-if="
                                          tickets &&
                                          worker?.ticket?.status === 'pending'
                                        "
                                      >
                                        <label
                                          style="
                                            font-weight: 600;
                                            font-size: 14px;
                                          "
                                          >Tiquetes aereos</label
                                        >
                                        <b-form-group
                                          v-slot="{ ariaDescribedby }"
                                        >
                                          <div class="d-flex">
                                            <b-form-radio
                                              v-model="
                                                tiquetes[worker.sharp_id]
                                              "
                                              :aria-describedby="
                                                ariaDescribedby
                                              "
                                              :name="`ticket-aereos-${worker.sharp_id}`"
                                              :value="true"
                                              :disabled="
                                                approvals.find(
                                                  (item) =>
                                                    item.sharp_id ==
                                                      worker.sharp_id &&
                                                    item.status == 'approved'
                                                )
                                                  ? false
                                                  : true
                                              "
                                              >Aprobar</b-form-radio
                                            >
                                            <b-form-radio
                                              v-model="
                                                tiquetes[worker.sharp_id]
                                              "
                                              :aria-describedby="
                                                ariaDescribedby
                                              "
                                              :name="`ticket-aereos-${worker.sharp_id}`"
                                              :value="false"
                                              class="ml-4"
                                              >Rechazar</b-form-radio
                                            >
                                          </div>
                                        </b-form-group>
                                        <!-- <b-form-radio-group
                                          v-model="tiquetes[worker.sharp_id]"
                                          :options="options"
                                          value-field="item"
                                          text-field="name"
                                        ></b-form-radio-group> -->
                                      </div>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        class="button3"
                                        v-on:click="
                                          handleClickAll(
                                            worker.core_employee.sharp_id
                                          )
                                        "
                                        :disabled="isDisabled"
                                      >
                                        <p class="p1">Aprobar todos</p>
                                      </button>
                                    </td>
                                    <td
                                      align="center"
                                      v-for="(day, key_day) in worker.days"
                                      :key="key_day"
                                    >
                                      <div id="ck-button">
                                        <label>
                                          <input
                                            type="checkbox"
                                            :id="
                                              worker.core_employee.sharp_id +
                                              '/' +
                                              day.day
                                            "
                                            v-model="
                                              selectedPersons[
                                                worker.core_employee.sharp_id +
                                                  '/' +
                                                  day.day
                                              ]
                                            "
                                            :value="day.day"
                                            v-on:change="
                                              handlePerson(
                                                worker.core_employee.sharp_id,
                                                day.day,
                                                $event
                                              )
                                            "
                                            number
                                            hidden
                                          />
                                          <span>
                                            {{ day.day.substring(8, 10) }}
                                          </span>
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                </table>

                                <div class="mt-4" v-if="isEditLicenseForDay">
                                  <p>Dar click en consolidar fechas</p>
                                  <button
                                    type="button"
                                    class="btn btn-darkblue-1"
                                    style="font-size: 14px"
                                    v-on:click="updateState"
                                  >
                                    Consolidar fechas
                                  </button>
                                </div>
                                <div class="row mt-3">
                                  <div class="col-12 text-center">
                                    <small v-show="diffDate < 3">
                                      <b-alert show variant="danger">
                                        ATENCIÓN: Esta solicitud se creó con
                                        menos de 3 días de anticipación.
                                      </b-alert>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-3">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            class="button1 d-flex flex-row justify-content-between align-items-center"
                            block
                            v-b-toggle.accordion-2
                            variant="info"
                            :disabled="isConsolidateDate ? false : true"
                          >
                            2. Justificación
                            <span class="when-opened ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-up.svg"
                                alt=""
                              />
                            </span>
                            <span class="when-closed ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-down.svg"
                                alt=""
                              />
                            </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse
                          id="accordion-2"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body v-if="licenseIsEdit" class="px-5">
                            <div class="mb-4">
                              <p
                                class="p2"
                                style="
                                  font-size: 16px;
                                  line-height: 18px !important;
                                "
                              >
                                Digita la razón de rechazo de días para cada
                                colaborador.
                              </p>
                              <table border="1" width="100%">
                                <thead>
                                  <tr>
                                    <td align="center">
                                      <p class="p2"><b>Colaborador</b></p>
                                    </td>
                                    <td align="center">
                                      <p class="p2"><b>Días no otorgados</b></p>
                                    </td>
                                    <td align="center">
                                      <p class="p2"><b>Razón</b></p>
                                    </td>
                                  </tr>
                                </thead>
                                <tbody
                                  v-for="(
                                    { rejectedString, core_employee },
                                    key_employee
                                  ) in employees"
                                  :key="key_employee"
                                  border="1"
                                >
                                  <tr v-if="rejectedString">
                                    <td>
                                      {{ core_employee.name }}
                                    </td>
                                    <td>
                                      {{ rejectedString }}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        v-model="reason[core_employee.sharp_id]"
                                        @input="makeObjectEditLetter()"
                                        class="form-control"
                                        style="font-size: 14px !important"
                                        maxlength="40"
                                        required
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              v-if="
                                ticketsCanBeApproved &&
                                ticketsApprobals.length > 0
                              "
                            >
                              <p
                                class="p2"
                                style="
                                  font-size: 16px;
                                  line-height: 18px !important;
                                "
                              >
                                Digita la razón de rechazo de tiquetes para cada
                                colaborador.
                              </p>
                              <table border="1" width="100%">
                                <thead>
                                  <tr>
                                    <td align="center">
                                      <p class="p2"><b>Colaborador</b></p>
                                    </td>
                                    <td align="center">
                                      <p class="p2"><b>Razón</b></p>
                                    </td>
                                  </tr>
                                </thead>
                                <tbody
                                  v-for="{
                                    name,
                                    reason,
                                    sharp_id,
                                    isTicket,
                                    isDisabled,
                                  } in ticketsApprobals"
                                  :key="sharp_id"
                                  border="1"
                                >
                                  <tr v-if="!isTicket">
                                    <td>
                                      {{ name }}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        :value="reason"
                                        @input="
                                          addReasonTicketApprobals(
                                            $event,
                                            sharp_id
                                          )
                                        "
                                        class="form-control"
                                        style="font-size: 14px !important"
                                        maxlength="40"
                                        required
                                        :readonly="isDisabled"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <b-card no-body class="mb-3">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            class="button1 d-flex flex-row justify-content-between align-items-center"
                            block
                            v-b-toggle.accordion-3
                            variant="info"
                            :disabled="isConsolidateDate ? false : true"
                          >
                            3. Comentarios
                            <span class="when-opened ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-up.svg"
                                alt=""
                              />
                            </span>
                            <span class="when-closed ml-2">
                              <img
                                class="centerImg1"
                                src="@/assets/images/icons/chevron-down.svg"
                                alt=""
                              />
                            </span>
                          </b-button>
                        </b-card-header>
                        <b-collapse
                          id="accordion-3"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body v-if="isEditLicenseForDay" class="px-5">
                            <b-card-text>
                              <div class="row">
                                <div class="col-12 mb-md-5">
                                  <textarea
                                    class="form-control"
                                    v-model="comments"
                                    placeholder="Ingresar comentario..."
                                    ref="input"
                                    rows="5"
                                    required
                                    style="font-size: 14px !important"
                                  >
                                  </textarea>
                                </div>
                              </div>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <div class="row">
                        <div class="col-12 pt-5" align="center">
                          <small v-show="error.flag" class="alert-danger">
                            <b align="center">{{ error.message }}</b>
                          </small>
                          <small v-show="success.flag" class="alert-heading">
                            <b-alert show variant="success">
                              <strong>{{ success.message }}</strong>
                            </b-alert>
                          </small>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6 pt-0" align="center">
                          <router-link to="/solicitudes">
                            <button class="btn btn-block btn-white-1">
                              Volver
                            </button>
                          </router-link>
                        </div>
                        <div
                          v-show="licenseIsEdit && isConsolidateDate"
                          class="col-6 pt-0"
                          align="center"
                        >
                          <div v-if="isEditLicenseForDay">
                            <button
                              :disabled="processing_save_dates"
                              type="button"
                              class="btn btn-block btn-darkblue-1"
                              v-on:click="approvalDates"
                            >
                              Guardar fechas
                            </button>
                          </div>
                          <div
                            class="spinner-border"
                            role="status"
                            align="center"
                            v-else-if="loadingApproval"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <!--/div-->
                    </div>
                  </form>
                </div>
                <div>
                  <b-modal
                    ref="my-modal"
                    hide-footer
                    centered
                    title="Atención al mensaje:"
                    no-close-on-backdrop
                    @hidden="hideModal"
                  >
                    <div class="d-block text-center">
                      <h3>{{ this.msjModal }}</h3>
                    </div>
                    <b-button
                      class="mt-3"
                      variant="outline-danger"
                      block
                      @click="hideModal"
                    >
                      Cerrar
                    </b-button>
                  </b-modal>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6 pt-5 mb-5">
                <letter-template
                  :key="key_letter"
                  :is-edit-approval="isEditLicenseForDay && letter_is_edit"
                  :is-edit-retraction="show_letter_by_is_retraction"
                  :object-edit-approval="objectEditLetter"
                  :dataAvailableTickets="dataAvailableTickets"
                />
              </div>
            </template>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Approval",
  components: {
    MainBarMenu,
    HeadingUser,
    letterTemplate: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Letters/Letter.vue"
      ),
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      statusRequest: "",
      img1: "circle-clock.svg",
      img2: "circle-clock.svg",
      days: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      monthNames: [
        "cero",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      nameDaysLicense: [],
      nameMonthsLicense: [],
      stringMonths: "",
      selectedPersons: {},
      reason: {},
      turns: [],
      turnos: {},
      tiquetes: {},
      ticketsApprobals: [],
      reasons: [],
      isDisabled: false,
      employees: [],
      comments: "",
      comentario: "",
      contPos: 0,
      keyComponent: 0,
      approvals: [],
      tickets: "",
      msjModal: "",
      flagPath: 0,
      dates: [],
      datesOpen: [
        {
          start: null,
          end: null,
        },
      ],
      processing: true,
      key_letter: 0,
      objectEditLetter: [],
      processing_save_dates: false,
      letter_is_edit: false,
      dataAvailableTickets: null,
      isConsolidateDate: false,
      options: [
        { item: true, name: "Aprobar", disabled: true },
        { item: false, name: "Rechazar", disabled: false },
      ],
    };
  },
  watch: {
    comments() {
      this.makeObjectEditLetter();
    },
  },
  mounted() {
    this.processing = true;
    const license_id = this.$route.params.id;
    this.actGetRequest(license_id)
      .then(() => {
        this.dataAvailableTickets = {
          society_id: this.request.data.license.petitioner_society.id,
          startDate: this.request.data.license.startDate,
        };
        //this.date = new Date(this.request.data.license.startDate.replace(/-/g, ',')); // Fecha inicial para aprobar
        this.datesOpen[0].start = this.request.data.license.startDate.replace(
          /-/g,
          ","
        ); // Fecha inicial del permiso
        this.datesOpen[0].end = this.request.data.license.endDate.replace(
          /-/g,
          ","
        ); // Fecha final del permiso
        this.tickets = this.request.data.license.tickets;
        // Calcula las fechas dentro del rango seleccionado en la solicitud de permiso sindical
        let dates = [];
        let startDate = new Date(
          this.request.data.license.startDate.replace(/-/g, ",")
        );
        let endDate = new Date(
          this.request.data.license.endDate.replace(/-/g, ",")
        );
        const theDate = new Date(startDate);
        while (theDate <= endDate) {
          dates = [...dates, new Date(theDate)];
          theDate.setDate(theDate.getDate() + 1);
        }

        this.dates = dates;

        dates.forEach((date) => {
          this.nameDaysLicense.push({ day: this.days[date.getDay()] });
          this.nameMonthsLicense.push(this.monthNames[date.getMonth() + 1]);
        });
        let months = this.uniq(this.nameMonthsLicense);
        months.forEach((element) => {
          this.stringMonths += " " + element;
        });

        this.request.data.license.license_employees.forEach((colaboradores) => {
          if (colaboradores.ticket.status == "approved") {
            this.tiquetes[colaboradores.sharp_id] = true;
          }
          //Precarga información de la solicitud si ya ha sido rechazada o aprobada
          if (colaboradores.approver_id == this.user.id) {
            //Inicializa arrays para que a los aprobadores    solo les aparezca su equipo a cargo
            colaboradores.days.forEach((day) => {
              this.approvals.push({
                sharp_id: colaboradores.sharp_id,
                date: day.day,
                status: day.status != "approved" ? "rejected" : day.status,
              });
              this.selectedPersons[
                colaboradores.sharp_id + "/" + day.day
              ] = false; // Inicializa objeto con todos rechazados.
              if (day.status == "approved") {
                // check personas aprobadas para pintar de verde en la grilla
                this.selectedPersons[
                  colaboradores.sharp_id + "/" + day.day
                ] = true;
              }
            });
            // Precarga las razones de rechazo
            this.reason[colaboradores.core_employee.sharp_id] =
              colaboradores.reason;
          }
        });
        //Inicializa arrays para que a los aprobadores solo les aparezca su equipo a cargo
        this.request.data.license.license_employees.forEach((row) => {
          //alert(row.id);
          if (row.approver_id == this.user.id) {
            this.employees.push(row);
          }
        });

        if (this.request.data.license.lic_comments !== null) {
          this.comments = this.request.data.license.lic_comments.text;
        } else {
          this.comments = "";
        }
        this.statusRequest = this.request.data.license.status;
        this.getTraceabilityAction({ id: license_id });
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: " + response;
      })
      .finally(() => (this.processing = false));
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["request", "loading"]),
    ...mapState("modApproval", ["loadingApproval"]),

    diffDate: function () {
      let createAt = new Date(this.request.data.license.created_at);
      let startDate = new Date(this.request.data.license.startDate);
      var timeDiff = Math.abs(startDate.getTime() - createAt.getTime());
      return Math.ceil(timeDiff / (1000 * 3600 * 24));
    },
    ticketsCanBeApproved() {
      return this.request.data
        ? !!this.request.data.license.license_employees.find(
            ({ ticket, approver_id }) =>
              ticket.status === "pending" && approver_id === this.user.id
          )
        : false;
    },
    licenseIsEdit() {
      const states = {
        cancelled: false,
        closed: false,
      };
      if (this.statusRequest in states) return states[this.statusRequest];
      return true;
    },
    stateLicense() {
      const values = {
        cancelled: "**Esta solicitud fue cancelada y no puede modificarse**",
        closed: "**Esta solicitud ya fue aprobada y no puede modificarse**",
      };
      if (this.statusRequest in values)
        return { value: true, msj: values[this.statusRequest] };
      return { value: false, msj: this.statusRequest };
    },
    isEditLicenseForDay() {
      if (this.employees.length) {
        const permit = ["pending"];
        const result = this.arrayColumn(
          this.arrayFlat(this.arrayColumn(this.employees, "days"), "status"),
          "status"
        );

        return !!result.filter((item) => permit.indexOf(item) !== -1).length;
      }
      return false;
    },
    colaboradores() {
      return this.request.data.license.license_employees
        ? this.request.data.license.license_employees
        : [];
    },
    show_letter_by_is_retraction() {
      return !!this.colaboradores.find(({ status }) => status === "retraction");
    },
  },
  methods: {
    ...mapActions("modApproval", ["actSaveApproval"]),
    ...mapActions("modRequest", ["actGetRequest", "actSaveComments"]),
    ...mapActions("permisosSindicalesV2License", ["getTraceabilityAction"]),
    makeObjectEditLetter() {
      const me = this;
      me.objectEditLetter = me.employees.map(
        ({ approvalString, sharp_id, rejectedString, core_employee }) => {
          return {
            sharp_id,
            name: core_employee.name,
            cc: core_employee.cc,
            days_approval: approvalString || null,
            days_rejected: rejectedString || null,
            reason: me.reason[sharp_id],
            comments: me.comments,
            ticketsApprobals: me.ticketsApprobals,
          };
        }
      );
      this.letter_is_edit = true;
    },
    updateState() {
      const me = this;
      let monthsA = [];
      let monthsR = [];
      me.ticketsApprobals = [];
      const sharpIdTickets = [];
      if (Object.entries(me.tiquetes).length > 0) {
        Object.entries(me.tiquetes).forEach(([key, value]) => {
          sharpIdTickets.push({
            sharp_id: Number(key),
            ticket: value,
            status: value ? "approved" : "rejected",
          });
        });
      } else if (
        Object.entries(me.tiquetes).length === 0 &&
        me.ticketsCanBeApproved
      ) {
        me.showModal("Debe Aprobar o Rechazar tiquetes aereos", 0);
        return false;
      }

      me.employees.forEach((item) => {
        const record = sharpIdTickets.find((x) => x.sharp_id == item.sharp_id);
        me.ticketsApprobals.push({
          sharp_id: item.sharp_id,
          name: item?.core_employee?.name,
          reason: me.textReason(item, record?.ticket),
          status: me.statusTicket(item, record?.ticket),
          isTicket: record?.ticket ? true : false,
          isDisabled: item?.ticket?.status === "not_available" ? true : false,
        });
      });

      for (let i = 0; i < me.employees.length; i++) {
        monthsA = [];
        monthsR = [];
        me.employees[i]["approvalString"] = "";
        me.employees[i]["rejectedString"] = "";
        for (let j = 0; j < me.approvals.length; j++) {
          if (
            me.employees[i].sharp_id == me.approvals[j].sharp_id &&
            me.approvals[j].status == "approved"
          ) {
            me.employees[i]["approvalString"] +=
              me.approvals[j].date.substring(8, 10) + ", ";
            monthsA.push(
              me.monthNames[parseInt(me.approvals[j].date.substring(5, 7))]
            );
          }

          if (
            me.employees[i].sharp_id == me.approvals[j].sharp_id &&
            me.approvals[j].status != "approved"
          ) {
            me.employees[i]["rejectedString"] +=
              me.approvals[j].date.substring(8, 10) + ", ";
            //alert("Rechazado "+me.approvals[j].date);
            monthsR.push(
              me.monthNames[parseInt(me.approvals[j].date.substring(5, 7))]
            );
          }
        }
        // Generamos los meses para imprimir 1 sola vez
        if (me.employees[i]["approvalString"]) {
          let months1 = me.uniq(monthsA);
          months1.forEach((element) => {
            me.employees[i]["approvalString"] += " " + element;
          });
          me.employees[i]["approvalString"] += ".";
        }
        if (me.employees[i]["rejectedString"]) {
          let months2 = me.uniq(monthsR);
          months2.forEach((element) => {
            me.employees[i]["rejectedString"] += " " + element;
          });
          me.employees[i]["rejectedString"] += ".";
        }
      }
      me.makeObjectEditLetter();
      me.isConsolidateDate = true;
      me.$root.$emit("bv::toggle::collapse", "accordion-2");
    },

    textReason(item, ticket) {
      let text = null;
      if (item?.ticket?.status == "not_available") {
        text = "Rechazado por límite de tiquetes.";
      } else if (item?.ticket?.status !== "not_available" && !ticket) {
        text = "";
      }

      return text;
    },
    statusTicket(item, ticket) {
      let status = "approved";
      if (item?.ticket?.status == "not_available") {
        status = "not_available";
      } else if (item?.ticket?.status !== "not_available" && !ticket) {
        status = "rejected";
      }

      return status;
    },

    handlePerson(sharp_id, day) {
      //alert(sharp_id+" "+day);
      //alert(this.selectedPersons[sharp_id+'/'+day]);
      for (let i = 0; i < this.approvals.length; i++) {
        if (
          this.approvals[i].sharp_id == sharp_id &&
          this.approvals[i].date == day
        ) {
          //alert(this.selectedPersons[sharp_id+'/'+day]);
          this.approvals[i].status =
            this.selectedPersons[sharp_id + "/" + day] === true
              ? "approved"
              : "rejected";
        }
      }
      //this.keyComponent += 1;
    },

    handleClickAll: function (sharp_id) {
      //alert(document.getElementById(sharp_id).checked);
      this.dates.forEach((date) => {
        document.getElementById(
          sharp_id + "/" + this.formatDate(date)
        ).checked = true;
        this.selectedPersons[sharp_id + "/" + this.formatDate(date)] = true;
        this.handlePerson(sharp_id, this.formatDate(date));
      });
      //this.keyComponent += 1; // Actualiza TemplateLetter
    },

    async approvalDates() {
      const me = this;
      const ticketsApprobals = [];
      me.turns = [];
      me.reasons = [];
      // Controla que se hayan ingresado todas las razones de rechazo
      let validation = 0;
      me.approvals.forEach((worker) => {
        if (worker.status == "rejected") {
          //alert(me.reason[worker.sharp_id]);
          if (
            typeof me.reason[worker.sharp_id] === "undefined" ||
            me.reason[worker.sharp_id] == "" ||
            me.reason[worker.sharp_id] == null
          ) {
            validation += 1;
          }
        }
      });

      if (validation > 0) {
        me.showModal("Debe ingresar todas las razones de rechazo de días", 0);
        return false;
      }

      if (me.ticketsCanBeApproved) {
        const record = me.ticketsApprobals.find(
          (x) => !x.isTicket && x?.reason == ""
        );

        if (record) {
          me.showModal(
            "Debe ingresar todas las razones de rechazo de tiquetes",
            0
          );
          return false;
        }
      }

      if (me.comments == "") {
        me.showModal("Debe ingresar un comentario", 0);
        return false;
      }

      // Crea estructura de razones para enviar al servicio
      for (let motivo in me.reason) {
        me.reasons.push({
          sharp_id: motivo,
          reason: me.reason[motivo],
        });
      }

      if (me.ticketsCanBeApproved) {
        me.ticketsApprobals.forEach((ticket) => {
          ticketsApprobals.push({
            sharp_id: ticket.sharp_id,
            status: ticket.status,
            reason: ticket.reason,
          });
        });
      }
      /*me.employees.forEach(worker => {
        if(me.reason[worker.sharp_id]){
          me.reasons.push({
          "sharp_id": worker.sharp_id,
          "reason": me.reason[worker.sharp_id]
          });
        }
      });*/

      // Crea estructura para el turno nocturno
      for (let turno in me.turnos) {
        if (me.turnos[turno] == true) {
          me.turns.push({
            sharp_id: turno,
          });
        }
      }

      let data = [];
      data[0] = me.$route.params.id;
      if (me.comments === "") {
        me.comments = "Sin comentarios";
      }
      data[1] = {
        lic_comments: {
          license_id: me.$route.params.id,
          text: me.comments,
        },
        status: me.approvals,
        reasons: me.reasons,
        night_shifts: me.turns,
        tickets: me.tickets,
        ticketsApprobals: ticketsApprobals,
      };

      me.processing_save_dates = true;
      await me
        .actSaveApproval(data)
        .then(() => {
          me.key_letter += 1;
          me.showModal(
            "Las fechas quedaron actualizadas en el sistema, por favor revisar la carta",
            0
          );
        })
        .catch((response) => {
          me.error.flag = true;
          me.error.class = "is-invalid";
          me.error.message = "No se pudo conectar al servicio: " + response;
        })
        .finally(() => (me.processing_save_dates = false));
    },

    updateComment() {
      if (this.comentario) {
        let data = "";
        data = {
          license_id: this.$route.params.id,
          core_employee_id: this.user.id,
          text: this.comentario,
        };
        //alert(JSON.stringify(data));

        this.actSaveComments(data)
          .then(() => {
            this.success.flag = true;
            this.success.class = "is-valid";
            this.success.message = "El comentario quedó guardado";

            this.actGetRequest(this.$route.params.id)
              .then(() => {
                this.comments = this.request.data.license.lic_comments;
              })
              .catch(() => {
                this.error.flag = true;
                this.error.class = "is-invalid";
                this.error.message = "No se pudo conectar al servicio";
              });
            this.comentario = "";
          })
          .catch(() => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message =
              "Ocurrio un error al guardar por favor actualizar la pagina.";
          });
      } else {
        this.showModal("Debe ingresar un comentario", 0);
      }
    },

    formatDateShow(date) {
      var d = new Date(date);
      var datestring =
        d.getDate() +
        " " +
        this.monthNames[d.getMonth() + 1] +
        " " +
        d.getFullYear();
      return datestring;
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/solicitudes" });
      }
    },
    uniq(a) {
      var seen = {};
      var out = [];
      var len = a.length;
      var j = 0;
      for (var i = 0; i < len; i++) {
        var item = a[i];
        if (seen[item] !== 1) {
          seen[item] = 1;
          out[j++] = item;
        }
      }
      return out;
    },
    addReasonTicketApprobals(event, sharp_id) {
      const me = this;
      me.ticketsApprobals.forEach((item) => {
        if (item.sharp_id == sharp_id) {
          item.reason = event.target.value;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");
.page-approval {
  .title-1 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }
  .cont-approval-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-approval {
      .form-group-req {
        label {
          position: absolute;
          color: #454545;
          font-size: 12px;
          background-color: #e9ecee;
          padding: 4px;
          top: -16px;
          left: 10px;
        }
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
      .button1 {
        font-family: "Open Sans";
        background: #e9ecee;
        color: #1c3a4e;
        font-weight: bold;
        //border-radius: 50px;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        outline: none;
        border: none;
        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }
      .button2 {
        background: #1c3a4e;
        color: #ffffff;
        border-radius: 50px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#cddce6, 5);
        }
      }
      .button3 {
        border: none;
        background-color: inherit;
        padding: 0px 10px;
        font-size: 11px;
        cursor: pointer;
        display: inline-block;
        text-decoration: underline;
      }
      .button4 {
        background: #99a6af;
        color: #ffffff;
        border-radius: 8px;
        height: 32px;
        font-size: 16px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        &:hover {
          background: darken(#99a6af, 5);
        }
      }
      tr {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #454545;
        padding-left: 5%;
      }
      .p1 {
        font-family: "Open Sans";
        font-style: normal;
        font-size: 11px;
        line-height: 12px;
        color: #888888;
        //display: block;
        padding-left: 15px;
        //text-indent: -15px;
      }
      .p2 {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 12px;
        color: #454545;
        padding-left: 5%;
      }
      .p3 {
        color: #1c3a4e;
        height: 32px;
        font-size: 16px;
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
      }
    }
  }
  .td1 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #1c3a4e;
    border-color: #1c3a4e;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

  /*.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }*/
  .img1 {
    width: 18px;
    height: 18px;
    //position: absolute;
    left: 100%;
    top: 100%;
    //margin-left: -9px;
    //margin-top: 9px;
    float: center;
    //clear: center;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    //position: absolute;
    //left: 50%;
    top: 100%;
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: center;
  }

  /*div label input {
   margin-right:100px;
  }
  body {
      font-family:sans-serif;
  }*/

  #ck-button {
    margin: 3px;
    background-color: #e2e0e0;
    border-radius: 4px;
    border: 0px solid #d0d0d0;
    //overflow:auto;
    //float:left;
  }

  #ck-button label {
    float: left;
    width: 2em;
  }

  #ck-button label span {
    text-align: center;
    padding: 2px 2px;
    display: block;
    border-radius: 4px;
  }

  #ck-button label input {
    position: absolute;
    top: -20px;
  }

  #ck-button input:hover + span {
    background-color: #bfb6b6;
  }

  #ck-button input:checked + span {
    background-color: rgb(20, 204, 17);
    color: #fff;
  }

  #ck-button input:checked:hover + span {
    background-color: rgb(164, 235, 163);
    color: #fff;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }
    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
}
</style>
